import React, { useRef } from 'react';
import { generateFormattedDate } from './assets/generateFormattedDate';
import { Badge } from 'reactstrap';
import FlexLightbox from './FlexLightbox';
import { FaReply, FaRobot } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import ChatImageWithLightbox from './components/ChatImageWithLightbox';
import {
  AudioContent,
  ImageContent,
  MessageContent,
  MessageText,
  ReplyIconContainerUser,
  ReplyIconContainerUserDisabled,
  UserContent,
  UserExternalContent,
  UserName,
  UserTimestamp
} from './components/styled';
import './style.css';

import { getStatusIcon } from './assets/eventStatusUtils';
import ReplyMessage from './components/ReplyMessage';
import { isSourceExpired, handleDownloadMedia } from './utils';
import { MdFileDownload } from 'react-icons/md';
import { AudioChatBallon } from './styled';
import { FileMessageBallon } from './components/FileMessage/FileMessage';

const UserMessage = ({
  message = '',
  time = '',
  name = '',
  type = 'text',
  options = '',
  description = '',
  source = '',
  sourceType = '',
  status = {},
  context,
  whatsappMessageId,
  scrollToMessage,
  highlighted,
  isAutomatic = false,
  fileName = '',
  todasMensagens,
  isClientNotActive = false,
  setInReplyToMessageId,
  hasMetaId = true
}) => {
  const isExpired = isSourceExpired(source, time);
  if (isExpired !== undefined && isExpired) {
    type = 'text';
    message = 'Link expirado com mais de 7 dias.';
    source = '';
  }

  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const messageRef = useRef(null);

  const handleAnswerMessage = () => {
    setInReplyToMessageId(whatsappMessageId);
  };

  const handleScrollToMessage = () => {
    if (context && context.id_mensagem_whatsapp) {
      scrollToMessage(context.id_mensagem_whatsapp);
    }
  };

  function linkify(message) {
    const urlPattern = /(https?:\/\/[^\s]+)/gim;
    let parts = '';

    if (typeof message === 'string') {
      parts = message?.split(urlPattern);

      const elements = parts.map((part, index) => {
        if (part.match(urlPattern)) {
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
            >
              {part}
            </a>
          );
        } else {
          // Se não corresponder a uma URL, retorna o texto normal
          return <span key={index}>{part}</span>;
        }
      });

      return <>{elements}</>;
    }
  }

  const isValidImageSource = (url) => {
    return url && /^(https?:\/\/|data:image\/)/.test(url);
  };

  const isOptimistic = typeof status === 'string' ? status === 'sending' : status?.situation === 'sending';

  return (
    <UserExternalContent>
      {!isClientNotActive && !hasMetaId && (
        <ReplyIconContainerUserDisabled title="Aguardando sincronização com WhatsApp...">
          <FaReply />
        </ReplyIconContainerUserDisabled>
      )}
      {whatsappMessageId && !isClientNotActive && hasMetaId && (
        <ReplyIconContainerUser>
          <FaReply onClick={handleAnswerMessage} title="Responder" />
        </ReplyIconContainerUser>
      )}
      <UserContent
        color={systemConfiguration.primary_color}
        ref={messageRef}
        id={whatsappMessageId}
        highlighted={highlighted}
        isOptimistic={isOptimistic}
      >
        {context && (
          <ReplyMessage
            context={context}
            handleScrollToMessage={handleScrollToMessage}
            color={'#d1d1d1'}
            backgroundColor={systemConfiguration.primary_color}
            textColor={'#fff'}
          />
        )}
        <UserName>
          {name}
          {isAutomatic ? (
            <FaRobot
              style={{ display: 'block', marginLeft: '.25rem' }}
              title="Mensagem automática"
            />
          ) : null}
          :
        </UserName>
        <MessageContent>
          <MessageText>
            {(message && options) ||
              (message &&
                (type === 'link' ? <div>{linkify(message)}</div> : message)) ||
              options}
            {(type === 'file' || type === 'DOCUMENT') && (
              <>
                <div>
                  <FileMessageBallon source={source} description={fileName} sourceType={sourceType} />
                  <MessageText>{description}</MessageText>
                </div>
              </>
            )}
          </MessageText>
          {options && (
            <Badge
              className="user-option"
              color="light"
              title={`Opção da ${name}`}
            >
              Opção
            </Badge>
          )}
          {type === 'image' && isValidImageSource(source) && (
            <ChatImageWithLightbox
              source={source}
              description={description}
              todasMensagens={todasMensagens}
              LightboxComponent={FlexLightbox}
              typeFilter={['image', 'sticker', 'video']}
            />
          )}
          {type === 'audio' && (
            <AudioContent style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AudioChatBallon src={source} controls={true} autoPlay={false} controlsList="nodownload" />
              <MdFileDownload
                size={24}
                style={{ cursor: 'pointer', color: '#6a5acd', flexShrink: 0 }}
                onClick={(e) => {
                  e.stopPropagation();
                  const ext = source.split('.').pop().split(/#|\?/)[0] || 'mp3';
                  handleDownloadMedia(source, ext, sourceType);
                }}
              />
            </AudioContent>
          )}
          {type === 'video' && (
            <div>
              <ImageContent style={{ position: 'relative' }}>
                <video
                  src={source}
                  autoPlay={false}
                  controls={true}
                  controlsList="nodownload"
                  width="100%"
                  height="300"
                />
                <MdFileDownload
                  size={24}
                  style={{ position: 'absolute', top: 10, right: 10, zIndex: 10, cursor: 'pointer', color: '#fff', background: 'rgba(0,0,0,0.5)', borderRadius: '50%', padding: '4px' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    const ext = source.split('.').pop().split(/#|\?/)[0] || 'mp4';
                    handleDownloadMedia(source, ext, sourceType);
                  }}
                />
              </ImageContent>
              <MessageText>{description}</MessageText>
            </div>
          )}
        </MessageContent>
        <UserTimestamp>
          {time && generateFormattedDate(time)}{' '}
          {status && getStatusIcon(status)}
        </UserTimestamp>
      </UserContent>
    </UserExternalContent>
  );
};

export default UserMessage;
